import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Fleet, FleetDashboardWidget, FleetDashboardWidgetDetail, FleetImage } from '../_models/fleet.models';
import { LoginHelper } from '../helpers';
import { AuthenticationService, TenantService } from './index';
import { IndexConfigService } from './index.config.service';

@Injectable({
  providedIn: 'root'
})
export class FleetsService {
  private readonly baseUrl = '/api/fleets';

  constructor(
    public http: HttpClient,
    public authenticationService: AuthenticationService,
    public config: IndexConfigService) { }

  getAll(includeChildren = true): Observable<Fleet[]> {
    const params = new HttpParams()
      .set('includeChildren', includeChildren);

    return this.http.get<Fleet[]>(this.baseUrl, { params });
  }

  getById(fleetId: number, includeChildren = true): Observable<Fleet> {
    const params = new HttpParams()
      .set('includeChildren', includeChildren);

    return this.http.get<Fleet>(
      `${this.baseUrl}/${fleetId}`,
      { params }
    );
  }

  getDashboard(includeChildren = true): Observable<FleetDashboardWidget[]> {

    return this.http.get<FleetDashboardWidget[]>(`${this.baseUrl}/dashboard`);
  }

  getDashboardDetail(fleetId: number): Observable<FleetDashboardWidgetDetail> {

    return this.http.get<FleetDashboardWidgetDetail>(`${this.baseUrl}/dashboard-detail/${fleetId}`);
  }

  create(fleet: Fleet): Observable<Fleet> {
    return this.http.post<Fleet>(this.baseUrl, fleet);
  }

  update(fleet: Fleet): Observable<Fleet> {
    return this.http.put<Fleet>(
      `${this.baseUrl}/${fleet.fleetId}`,
      fleet
    );
  }

  updateDeep(fleet: Fleet): Observable<Fleet> {
    return this.http.put<Fleet>(
      `${this.baseUrl}/${fleet.fleetId}/deep`,
      fleet
    );
  }

  delete(fleetId: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${fleetId}`);
  }

  uploadImage(fleetId: number, fleetImageFile: File): Observable<FleetImage> {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    let formData = new FormData();

    formData.append(fleetImageFile.name, fleetImageFile);
    return this.http
      .post<FleetImage>(`${this.baseUrl}/${fleetId}/image`, formData);
  }
}
